import React, { useEffect, useState } from 'react';
import Button from '@techsoftware/happay-widgets/Button';
import DialogBox from '@techsoftware/happay-widgets/DialogBox';
import Grid from '@techsoftware/happay-widgets/Grid';
import {
  currencyFormatter,
  formatDate,
  decimalFormatter,
} from '@techsoftware/happay-widgets/CommonFunction/commonFunction';
import SplitInputField from '@techsoftware/happay-widgets/SplitInputField';
import Spinner from '@techsoftware/happay-widgets/Spinner';
import Animation from '../../animation';
import history from '../../../utils/history';
import OverLimitPaymentIntimation from '../OverLimitPaymentIntimation';
import CutoffTimeIntimation from '../CutoffTimeIntimation';

const ErrorPrompt = props => {
  const {
    error,
    invoiceSubmitConfirmation,
    generateOTP,
    handleActionClick,
    userInfo = {},
    setInvoicePromptError,
    workflow,
    walletLimit = {},
    invoiceDetails = {},
  } = props;
  const [state, setState] = useState({
    openDialog: false,
    openOTP: false,
    otp: '',
    success: false,
    disableResend: false,
  });

  const {
    openDialog = false,
    openOTP = false,
    otp,
    success = false,
    disableResend,
  } = state;

  useEffect(() => {
    if (error) {
      setState({
        ...state,
        openDialog: true,
      });
    } else if (!error) {
      setState({
        ...state,
        openDialog: false,
        openOTP: false,
        otp: '',
        success: false,
        disableResend: false,
      });
    }
  }, [error]);

  useEffect(() => {
    if (invoiceSubmitConfirmation) {
      setState({
        ...state,
        success: true,
      });
    }
  }, [invoiceSubmitConfirmation]);

  const onClose = () => {
    setState({
      ...state,
      openDialog: false,
    });
    setInvoicePromptError('');
  };

  const handleConfirm = () => {
    if (openDialog && !openOTP && !success) {
      generateOTP();
      setState({
        ...state,
        openOTP: true,
      });
    } else if (openOTP && !success) {
      handleActionClick(otp);
    } else {
      setState({
        openOTP: false,
        openDialog: false,
        success: false,
        otp: '',
      });
      history.push(
        `/invoice/${workflow ? 'myapproval?tab=Pending' : 'myinvoice?tab=All'}`,
      );
    }
  };

  const handleInput = (e, val) => {
    setState({
      ...state,
      otp: val,
    });
  };

  const handleResendOTP = () => {
    startResendTimer();
    generateOTP();
    setState({
      ...state,
      disableResend: true,
    });
  };

  const startResendTimer = () => {
    const display = document.querySelector('#timer-1');
    let count = 60;
    const timeInterval = setInterval(() => {
      if (count === 0) {
        display.textContent = '';
        setState({
          ...state,
          disableResend: false,
        });
        clearInterval(timeInterval);
      } else if (display) {
        display.textContent = count--;
      }
    }, 1000);
  };

  const returnOTPInput = () => {
    const {
      mobile_extension: mobileExtension = '',
      mobile_number: mobileNumber = '',
      email_id: emailId = '',
    } = userInfo;
    const mobNumber1 = mobileNumber.slice(0, 5);
    const mobNumber2 = mobileNumber.slice(6, 10);
    return (
      <div className="otp-dialog-container">
        <div className="body">
          An OTP has been sent to your mobile number
          <span className="fw-500">
            {' '}
            {mobileExtension} {mobNumber1} {mobNumber2}
          </span>{' '}
          and to your email address
          <span className="fw-500"> {emailId}</span>
        </div>
        <SplitInputField
          id="otp"
          length={6}
          value={otp}
          handleChange={handleInput}
          floatingLabelText="Enter OTP"
          isNumberType
          customInputLabelStyle={{
            marginTop: '20px',
            textAlign: 'left',
          }}
          autoFocus
        />
        <Grid container justify="space-between" className="margin-t-10">
          <div
            onClick={disableResend ? () => {} : handleResendOTP}
            className={`font-12 fw-500 ${
              disableResend ? 'body light' : 'pointer primary-blue-color'
            } pos-relative flex-center`}
          >
            Resend OTP
            {disableResend && <span className="margin-l-6">in</span>}
            <div className="pos-relative flex-center">
              {disableResend && <Spinner className="margin-l-6" />}
              <div className="timer-counter align-center" id="timer-1"></div>
            </div>
          </div>
          <div className="body font-12">The OTP is valid for 5 mins only</div>
        </Grid>
      </div>
    );
  };

  const returnConfirm = () => (
    <div className="align-center">
      <Animation type="confetti" autoPlay play height={100} width={100} />
      <h2>Congratulations!</h2>
      You have successfully submitted the OTP and your payment has been
      proccessed.
    </div>
  );

  const returnAmountDetails = (
    title,
    key,
    data,
    extraEle,
    containerClass = '',
  ) => (
    <Grid
      container
      item
      justify="space-between"
      className={`font-12 fw-500 body ${containerClass}`}
    >
      <Grid item container justify="flex-start" className="padding-8" xs={18}>
        {title}
      </Grid>
      <Grid item container justify="flex-end" xs={6} className="padding-8">
        {extraEle ? <span className="margin-r-6">{extraEle}</span> : null}{' '}
        {currencyFormatter(data[key], data.currency)}
      </Grid>
    </Grid>
  );

  const returnError = error => {
    const {
      amount_breakdown = {},
      amount,
      payment_date,
      vendor_details,
    } = invoiceDetails;
    const { happay_processing_fee_percent = '1.4%' } = userInfo;
    const { tax_amount = 0, discount = 0, tds_amount = 0 } = amount_breakdown;

    return (
      <div>
        <div className="body">
          Vendor Name:{' '}
          <span className="body dark fw-500">
            {vendor_details?.vendor?.display_name}
          </span>
        </div>
        <div className="body margin-t-10 d-flex">
          Payment Scheduled Date:{' '}
          <span className="body dark fw-500 margin-lr-6">
            {formatDate(payment_date, 'DD MMM, YYYY')}
          </span>
          <CutoffTimeIntimation />
        </div>
        <Grid
          container
          item
          justify="center"
          alignItems="center"
          className="margin-tb-20 border-b border-t border-l border-r border-radius-4 padding-20"
        >
          {returnAmountDetails('Gross Amount', 'amount', invoiceDetails)}
          {returnAmountDetails(
            `GST${+tax_amount ? `(${decimalFormatter(tax_amount, 2)}%)` : ''}`,
            'tax_amount',
            {
              tax_amount:
                (decimalFormatter(tax_amount, 2) * (amount - (discount || 0))) /
                100,
            },
            '(+)',
          )}
          {returnAmountDetails(
            `TDS${+tds_amount ? `(${decimalFormatter(tds_amount, 2)}%)` : ''}`,
            'tds_amount',
            {
              tds_amount:
                (decimalFormatter(tds_amount, 2) * (amount - (discount || 0))) /
                100,
            },
            '(-)',
          )}
          {returnAmountDetails(
            'Discount',
            'discount',
            {
              ...invoiceDetails,
              ...(amount_breakdown || {}),
            },
            '(-)',
          )}
          {returnAmountDetails(
            `Happay Processing Fee @ ${happay_processing_fee_percent} (incl. GST)`,
            'happay_processing_fee',
            invoiceDetails,
            '(+)',
            'primary-color fw-600 margin-b-6',
          )}
          {returnAmountDetails(
            'Total Amount Payable',
            'final_amount',
            invoiceDetails,
            null,
            'dark font-14 border-t',
          )}
        </Grid>
        <div className="body font-12">
          *An OTP will be sent to your registered number for authentication.
        </div>
      </div>
    );
  };

  const title =
    openDialog && !openOTP && !success
      ? 'Invoice Summary'
      : openOTP && !success
      ? 'Verify OTP'
      : 'Confirmation';
  const buttonText =
    openDialog && !openOTP && !success
      ? 'Generate OTP'
      : openOTP && !success
      ? 'Submit OTP'
      : `My ${workflow ? 'Approvals' : 'Invoice'}`;
  const body =
    openDialog && !openOTP && !success
      ? returnError(error)
      : openOTP && !success
      ? returnOTPInput()
      : returnConfirm();

  const showOverLimit = openDialog && !openOTP && !success;

  return (
    <DialogBox
      open={openDialog}
      id="error-prompt"
      onClose={onClose}
      title={!success && title}
      titleStyle={{ fontWeight: 500 }}
      actionBorder
      crossIcon
      width="540px"
      dialogTitleContainerStyle={{ paddingBottom: '0px', fontWeight: '600' }}
      actions={
        <Grid container justify={showOverLimit ? 'space-between' : 'flex-end'}>
          {showOverLimit && (
            <OverLimitPaymentIntimation
              limit={walletLimit}
              currency={userInfo.default_currency}
              invoiceAmount={invoiceDetails?.final_amount}
            />
          )}
          <Button
            type="button"
            text={buttonText}
            size="medium"
            variant={success ? 'tertiary' : 'primary'}
            disabled={openOTP && !success && otp.length < 6}
            onClick={handleConfirm}
          />
        </Grid>
      }
    >
      <div className="padding-lr-30 padding-b-30 padding-t-16">{body}</div>
    </DialogBox>
  );
};

export default ErrorPrompt;
